'use client';

import { UIComponent } from '@/components/core/components';
import clsx from 'clsx';
import { Dropdown, Logo } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import { useState } from 'react';
import { useLocalizedLinks, useMediaQuery, useMounted } from '@/components/core/hooks';
import { Image } from '@/components/core/components/atoms';
import SearchBar from '@/components/core/components/organism/search-bar';
import { useLayout } from '@/components/context/layout';
import InternalLink from '@/components/core/components/organism/internal-link';
import { categories } from '@/@constants';
import * as styles from './navbar.styles';
import Item from './_components/item';
import SideMenu from './_components/side-menu';

const Navbar: UIComponent = ({ className }) => {
  const [open, setOpen] = useState(false);
  const links = useLocalizedLinks();
  const mediqQuery = useMediaQuery();
  const [layoutState] = useLayout();
  const mounted = useMounted();

  return (
    <header className={clsx(styles.root, className)}>
      <InternalLink href={links.root()}>
        {mediqQuery.down('lg') && layoutState.searchNavbarVisible ? <Image src="/logo-square.png" alt="logo" width={40} height={40} /> : <Logo />}
      </InternalLink>
      {mounted && layoutState.searchNavbarVisible && <SearchBar className={styles.searchInput} align="right" />}
      <div className={styles.menu}>
        <Item icon="home" href={links.root()}>
          <Trans>Home</Trans>
        </Item>
        <Dropdown
          open={open}
          align="right"
          onMouseEnter={() => {
            setOpen(true);
          }}
          onMouseLeave={() => {
            setOpen(false);
          }}
        >
          <Dropdown.Trigger>
            <Item icon="search" href={links.explore()}>
              <Trans>Explore</Trans>
            </Item>
          </Dropdown.Trigger>
          <Dropdown.Content className={styles.dropdown}>
            <Dropdown.Item as={InternalLink} href={links.explore(categories.restaurants)}>
              <Trans>Restaurants</Trans>
            </Dropdown.Item>
            <Dropdown.Item as={InternalLink} href={links.explore(categories.movies)}>
              <Trans>Movies</Trans>
            </Dropdown.Item>
            <Dropdown.Item as={InternalLink} href={links.explore(categories.series)}>
              <Trans>Series</Trans>
            </Dropdown.Item>
            <Dropdown.Item as={InternalLink} href={links.explore(categories.fashion)}>
              <Trans>Fashion</Trans>
            </Dropdown.Item>
            <Dropdown.Item as={InternalLink} href={links.explore()}>
              <Trans>Other categories</Trans>
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown>
        <Item icon="map" href={links.map()}>
          <Trans>Near me</Trans>
        </Item>
      </div>
      {mediqQuery.down('md') && <SideMenu />}
    </header>
  );
};

export default Navbar;
